import { Space } from '@components/Space/Space';
import {
  Typography as FenixTypography,
  Rating,
  Tag,
} from '@pedidosya/web-fenix/atoms';
import styled from 'styled-components';
import { TagsRow } from '.';
import { CPCContainer, Row, TextSeparator } from '../styles/styles';
import { vendorItem as vendorItemTokens } from '../styles/vendorItem';
import { CategoriesRow } from './CategoriesRow';

const Typography = styled(FenixTypography)`
  &.two-line-ellipsis {
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
`;

const RatingContainer = styled.div`
  margin-top: ${({ theme }) => theme.space('spacing-component-xsmall')};
`;

const LeftColumn = styled.div`
  align-self: flex-start;
  display: flex;
  flex-wrap: nowrap;
`;

const RightColumn = styled.div`
  align-self: flex-start;
  display: flex;
  flex-direction: column;
`;

const textProps = vendorItemTokens.properties.fonts;

export const HeadlineRow = ({
  vendorName,
  isNew,
  rating,
  mainCategories,
  discountLabel,
  renderPlusTag,
  sponsoringLabel,
  shouldRenderSponsoringLabelInBody,
}) => (
  <>
    <Row color={textProps.headline.textColor}>
      <LeftColumn>
        <Typography
          className="two-line-ellipsis"
          component="h1"
          token={textProps.headline.typography}
        >
          {vendorName}
        </Typography>
      </LeftColumn>
      <Space mr={6} />

      {(!!discountLabel || !!renderPlusTag) && (
        <TagsRow discountLabel={discountLabel} renderPlusTag={renderPlusTag} />
      )}
      <Space mr={6} />
      <div style={{ marginBottom: 4 }}>
        <TextSeparator>·</TextSeparator>
      </div>
      <Space mr={6} />
      <RightColumn>
        <RatingContainer>
          {!isNew && rating > 0 && (
            <Rating data-testid="rating" value={rating} />
          )}
          {!!isNew && (
            <div style={{ marginTop: -2 }}>
              <Tag category="loud" label="Nuevo" />
            </div>
          )}
        </RatingContainer>
      </RightColumn>
      <Space mr={6} />
      {shouldRenderSponsoringLabelInBody && (
        <div style={{ marginBottom: 4 }}>
          <TextSeparator>·</TextSeparator>
        </div>
      )}
      <Space mr={6} />
      {shouldRenderSponsoringLabelInBody && (
        <CPCContainer>
          <Typography
            color="text-color-tertiary"
            token="font-label-midcontrast-small"
          >
            {sponsoringLabel}
          </Typography>
        </CPCContainer>
      )}
    </Row>
    {!!mainCategories && mainCategories.length > 0 ? (
      <CategoriesRow mainCategories={mainCategories} />
    ) : null}
  </>
);
